import { View } from "react-native";
import { Text } from "react-native-paper";
import Button from "../../components/Button";
import PopOver from "../../components/PopOver";

type MultipleDuesInvoicesModalProps = {
  onDismiss(): void;
  visible: boolean;
  pastDueOrderTitle: string;
};

const MultipleDuesInvoicesModal = ({ onDismiss, visible, pastDueOrderTitle }: MultipleDuesInvoicesModalProps) => {
  return (
    <PopOver visible={visible} onDismiss={onDismiss}>
      <Text className="mb-2 text-regular-normal font-700 text-ink-dark">Multiple Dues Invoices</Text>
      <Text className="text-regular-normal text-ink-dark mb-6">
        You have 2 unpaid invoices. Please pay the first invoice, titled “{pastDueOrderTitle}”, before addressing the more
        recent one.
      </Text>

      <View className="flex flex-row justify-end mt-2">
        <Button onPress={onDismiss} className="ml-2" size="small" mode="secondary">
          Okay
        </Button>
      </View>
    </PopOver>
  );
};

export default MultipleDuesInvoicesModal;
